import {
	Attachment,
	AvailabilityStatus,
	Translations,
	UUID,
} from '@/types/types';
import { ApiQueryKey } from '@/configs/apiQueryKey';
import { Driver } from './DriverApi';
import { MontageSystem } from './MontageSystemApi';
import { MontageType } from './MontageTypeApi';
import { PowerSupply } from './PowerSupplyApi';
import { ProductColor } from './ProductColorApi';
import { ProductType } from './ProductTypeApi';
import EntityApi, { BaseEntity } from './EntityApi';

export enum ComponentQuantityType {
	QUANTITY = 'QUANTITY',
	PER_METER = 'PER_METER',
	RUNNER = 'RUNNER',
	CONNECTOR = 'CONNECTOR',
}

export interface Component extends BaseEntity {
	name: string;
	code: string;
	price: number;
	quantityType: ComponentQuantityType;
	quantityFormula: string;
	runnerLengthCM: number;
	image: Attachment | null;

	productTypes?: ProductType[];
	productTypeIds: UUID[];
	montageTypes?: MontageType[];
	montageTypeIds: UUID[];
	montageSystems?: MontageSystem[];
	montageSystemIds: UUID[];
	productColors?: ProductColor[];
	productColorIds: UUID[];
	powerSupplies?: PowerSupply[];
	powerSupplyIds: UUID[];
	drivers?: Driver[];
	driverIds: UUID[];

	availabilityStatus: AvailabilityStatus;
	componentSystemTypeQuantity: Record<UUID, number | string>;

	translations: Translations<{
		name: string;
	}>;
}

class ComponentApi extends EntityApi<Component> {
	constructor() {
		super(ApiQueryKey.components);
	}
}

export default new ComponentApi();
